let usStates = [
    {
        id: "01",
        name: "Alabama",
        abrv: "AL"
    },
    {
        id: "02",
        name: "Alaska",
        abrv: "AK"
    },
    {
        id: "03",
        name: "Arizona",
        abrv: "AZ"
    },
    {
        id: "04",
        name: "Arkansas",
        abrv: "AR"
    },
    {
        id: "05",
        name: "California",
        abrv: "CA"
    },
    {
        id: "06",
        name: "Colorado",
        abrv: "CO"
    },
    {
        id: "07",
        name: "Connecticut",
        abrv: "CT"
    },
    {
        id: "08",
        name: "Delaware",
        abrv: "DE"
    },
    {
        id: "09",
        name: "Florida",
        abrv: "FL"
    },
    {
        id: "010",
        name: "Georgia",
        abrv: "GA"
    },
    {
        id: "011",
        name: "Hawaii",
        abrv: "HI"
    },
    {
        id: "012",
        name: "Idaho",
        abrv: "ID"
    },
    {
        id: "013",
        name: "Illinois",
        abrv: "IL"
    },
    {
        id: "014",
        name: "Indiana",
        abrv: "IN"
    },
    {
        id: "015",
        name: "Iowa",
        abrv: "IA"
    },
    {
        id: "016",
        name: "Kansas",
        abrv: "KS"
    },
    {
        id: "017",
        name: "Kentucky",
        abrv: "KY"
    },
    {
        id: "018",
        name: "Louisiana",
        abrv: "LA"
    },
    {
        id: "019",
        name: "Maine",
        abrv: "ME"
    },
    {
        id: "020",
        name: "Maryland",
        abrv: "MD"
    },
    {
        id: "021",
        name: "Massachusetts",
        abrv: "MA"
    },
    {
        id: "022",
        name: "Michigan",
        abrv: "MI"
    },
    {
        id: "023",
        name: "Minnesota",
        abrv: "MN"
    },
    {
        id: "024",
        name: "Mississippi",
        abrv: "MS"
    },
    {
        id: "025",
        name: "Missouri",
        abrv: "MO"
    },
    {
        id: "026",
        name: "Montana",
        abrv: "MT"
    },
    {
        id: "027",
        name: "Nebraska",
        abrv: "NE"
    },
    {
        id: "028",
        name: "Nevada",
        abrv: "NV"
    },
    {
        id: "029",
        name: "New Hampshire",
        abrv: "NH"
    },
    {
        id: "030",
        name: "New Jersey",
        abrv: "NJ"
    },
    {
        id: "031",
        name: "New Mexico",
        abrv: "NM"
    },
    {
        id: "032",
        name: "New York",
        abrv: "NY"
    },
    {
        id: "033",
        name: "North Carolina",
        abrv: "NC"
    },
    {
        id: "034",
        name: "North Dakota",
        abrv: "ND"
    },
    {
        id: "035",
        name: "Ohio",
        abrv: "OH"
    },
    {
        id: "036",
        name: "Oklahoma",
        abrv: "OK"
    },
    {
        id: "037",
        name: "Oregon",
        abrv: "OR"
    },
    {
        id: "038",
        name: "Pennsylvania",
        abrv: "PA"
    },
    {
        id: "039",
        name: "Rhode Island",
        abrv: "RI"
    },
    {
        id: "040",
        name: "South Carolina",
        abrv: "SC"
    },
    {
        id: "041",
        name: "South Dakota",
        abrv: "SD"
    },
    {
        id: "042",
        name: "Tennessee",
        abrv: "TN"
    },
    {
        id: "043",
        name: "Texas",
        abrv: "TX"
    },
    {
        id: "044",
        name: "Utah",
        abrv: "UT"
    },
    {
        id: "045",
        name: "Vermont",
        abrv: "VT"
    },
    {
        id: "046",
        name: "Virginia",
        abrv: "VA"
    },
    {
        id: "047",
        name: "Washington",
        abrv: "WA"
    },
    {
        id: "048",
        name: "West Virginia",
        abrv: "WV"
    },
    {
        id: "049",
        name: "Wisconsin",
        abrv: "WI"
    },
    {
        id: "050",
        name: "Wyoming",
        abrv: "WY"
    }
];

export function getUsStates() {
    return usStates;
}
